import React, { useEffect, useState } from 'react'
import parse from 'html-react-parser'
import { Fragment, ResourceType, Section, SubSection } from '../../../interfaces/Publication';
import LinkFragment from '../../utils/LinkFragment';

interface LeftMenuResourceProps {
    sections: Section[];
    resourceType : ResourceType;
    showLengthResources?: boolean;
    navigate?: boolean;
    showAloneTypeResource?: boolean;
}

const LeftMenuResource = ({sections, resourceType, showLengthResources = true, navigate = true, showAloneTypeResource = false}: LeftMenuResourceProps) => {

    const [fragments, setFragments] = useState<Fragment[]>([])
    const [active, setActive] = useState(false)

    useEffect(() => {

////////////////////////
// Esto hay qu earreglarlo para crear el vinculo bien
////////////////////////

        // const subsections: SubSection[] = sections.reduce((accumulator: SubSection[], section) => {
        //     return accumulator.concat(
        //         section.subsections ? section.subsections : []
        //     )
        // }, []).filter( subsection => subsection );

        // const fragments : Fragment[] =  subsections.reduce( (accumulator: Fragment[], subSection) =>{
        //     return accumulator.concat(
        //         subSection.fragments
        //     )
        // }, [])

        let fragments : Fragment[] =[]

        sections.forEach( (section, idxSection) =>{
            section.subsections?.forEach( (subSection, idxSubsection) => {
                subSection.fragments.forEach( (fragment, idxFragment) => {
                    fragments.push( {...fragment, ...{idxSection:idxSection}} )
                } )
            })
        })

        setFragments(fragments)
        //   console.log(fragments)
    }, [sections])


    if(fragments.filter( fragment => fragment.type === resourceType.abreviation ).length == 0){

        return(
            <></>
        )
    }

    return (
        <li className="nav__menu-item" >
            <a className={`nav__link ${active?"active":null }`}  href="javascript:void(0)" onClick = { ()=>{setActive(!active)} }
            ><span className="nav__icon"
                ><i className={`icon ${resourceType.class}`}  ></i></span
            >
                <span style={{ display: showLengthResources ? 'none' : 'inline'}}>
                    {resourceType.name}
                </span>
                <span style={{ display: showLengthResources ? 'inline' : 'none'}}>
                    {resourceType.name} ({fragments.filter( fragment => fragment.type === resourceType.abreviation ).length})
                </span>
            <div className="m-indicator" style={{ display: showAloneTypeResource ? 'none' : 'true'}}></div>
            </a>

        {/* //aqui debo ir por cada seccion, subscecion y fragmento para buscaar el tipo de recurso */}

            <div className="nav__menu-backdrop">
            <ul className="nav__submenu-lvl2 unstyled-list">
                {
                    fragments.filter( fragment => fragment.type === resourceType.abreviation ).map( (fragment, index) =>(
                        <li className="nav__submenu-item" key={index} style={{ display: showAloneTypeResource ? 'none' : 'true'}}>
                            {/* <a className="nav__link" href={``}>{fragment.title}</a> */}
                            <span style={{ display: navigate ? 'line' : 'none'}}>
                                <LinkFragment
                                    idxSection = {fragment.idxSection?fragment.idxSection:0}
                                    idAnchor = {`${fragment.type}${fragment.id}`}
                                    title = {fragment.title || fragment.name || ""}
                                ></LinkFragment>
                            </span>
                            <span style={{ display: navigate ? 'none' : 'line'}}>
                                <a className="nav__link">
                                    {`${parse(fragment.title ?? '')}`}
                                </a>
                            </span>
                        </li>                                  
                    ) )
                }
            
            </ul>
            </div>
      </li>
    )
}

export default LeftMenuResource
